import { useFormContext, useWatch } from "react-hook-form";
import  {useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { IRangeDate, useCompanyQuery } from "../../../../../../api/services";
import { FormTextField } from "../../../../../../components/fields";
import { IFormValues } from "../../../../types";
import { editBusinessAgreementCheckValidate, editBusinessAgreementCig, editMandatoryDossierIsRequired, editRangeDateValidity } from "../../../../recoil";

const FormCustomerCode = () => {

    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();

    const setBusinessAgreementCheckValidate = useSetRecoilState<boolean | undefined>(editBusinessAgreementCheckValidate);
    const setBusinessAgreementHasCig = useSetRecoilState<boolean | undefined>(editBusinessAgreementCig);
    const seMandatoryDossierIsRequired = useSetRecoilState<boolean | undefined>(editMandatoryDossierIsRequired);
    const setRangeDate = useSetRecoilState<IRangeDate | undefined>(editRangeDateValidity);

    const customerCode = useWatch<IFormValues, 'basicDetails.customerCode'>({
        name: 'basicDetails.customerCode'
    });

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });
    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenant" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealer" });

    const companyQuery = useCompanyQuery(
        {
            code: customerCode,
            segment: rentalType,
            tenant: tenant as string,
            dealer: dealer as string,
        },
        {
            enabled: false,
            onSuccess: (companyFound) => {
                setBusinessAgreementCheckValidate(false);
                setBusinessAgreementHasCig(!!companyFound?.cig && companyFound?.cig?.length > 0);
                seMandatoryDossierIsRequired(companyFound?.mandatoryDossier);
                setRangeDate(companyFound?.rangeDate);

                if (!companyFound && formContext.control.getFieldState('basicDetails.customerCode').isDirty) {
                    formContext.setError(
                        'basicDetails.customerCode',
                        {
                            message: 'message.validation.invalid_code'
                        }
                    );
                    return;
                }

                setBusinessAgreementCheckValidate(true);
                formContext.clearErrors('basicDetails.customerCode');

            },
            onError: () => {
                setBusinessAgreementCheckValidate(false);
                formContext.setError(
                    'basicDetails.customerCode',
                    {
                        message: 'message.validation.invalid_code'
                    }
                );
            },
        }
    );

    return (
        <FormTextField<IFormValues>
            name="basicDetails.customerCode"
            label={t('label.businessAgreement')}
            disabled={true}
            InputProps={{
                readOnly: true
            }}
            helperText={!!companyQuery.data ? companyQuery.data?.name + ' - ' + t(`creditType.${companyQuery.data?.creditType}`) : ''}
        />
    );
};

export default FormCustomerCode;
